function TrustAndSafety() {
  return (
    <div>
      {/* Hero section */}
      <section className="hero-section">
        <div className="hero-content">
          <h1>Trust & Safety</h1>
          <p>
            At AirArrange, trust and safety are fundamental to every interaction
            between landlords and tenants on our commercial real estate
            platform. We are committed to providing a secure, transparent, and
            compliant environment that supports fair dealings and long-term
            business relationships across Australia.
          </p>
        </div>
      </section>

      {/* Content section */}
      <section className="max-w-5xl mx-auto px-6 py-16 space-y-12">
        {/* Commitment */}
        <div>
          <h2 className="text-2xl font-semibold mb-4">Our Commitment</h2>
          <p className="text-gray-600">
            AirArrange is committed to promoting honest, transparent, and lawful
            commercial leasing practices. Our platform is designed to support
            both landlords and tenants by providing accurate information, clear
            processes, and professional standards of conduct.
          </p>
        </div>

        {/* Legal compliance */}
        <div>
          <h2 className="text-2xl font-semibold mb-4">
            Compliance with Australian Laws
          </h2>
          <p className="text-gray-600 mb-3">
            AirArrange operates in accordance with relevant Australian laws and
            regulations, including:
          </p>
          <ul className="list-disc pl-6 text-gray-600 space-y-2">
            <li>Australian Consumer Law (Competition and Consumer Act 2010)</li>
            <li>Privacy Act 1988 and Australian Privacy Principles</li>
            <li>
              State and territory commercial and retail leasing legislation
            </li>
            <li>Federal and state anti-discrimination laws</li>
          </ul>
        </div>

        {/* Transparency */}
        <div>
          <h2 className="text-2xl font-semibold mb-4">
            Transparency Between Landlords and Tenants
          </h2>
          <p className="text-gray-600">
            We encourage clear and accurate property listings, honest disclosure
            of lease terms, costs, and inclusions, and open communication prior
            to entering negotiations. Users are responsible for conducting their
            own due diligence before entering into any lease.
          </p>
        </div>

        {/* Platform integrity */}
        <div>
          <h2 className="text-2xl font-semibold mb-4">
            Platform Integrity & Verification
          </h2>
          <p className="text-gray-600">
            While AirArrange does not act as a leasing agent or legal advisor,
            we take reasonable steps to promote platform integrity. This
            includes monitoring listings, reviewing reported behaviour, and
            taking action where platform rules are breached.
          </p>
        </div>

        {/* Privacy */}
        <div>
          <h2 className="text-2xl font-semibold mb-4">
            Privacy & Data Protection
          </h2>
          <p className="text-gray-600">
            We handle personal and business information in accordance with the
            Privacy Act 1988. Information is collected only where necessary,
            stored securely, and used solely for its intended purpose. Users may
            request access to or correction of their information.
          </p>
        </div>

        {/* Financial safety */}
        <div>
          <h2 className="text-2xl font-semibold mb-4">
            Financial Safety & Payments
          </h2>
          <p className="text-gray-600">
            AirArrange does not hold or process rent, bonds, or lease payments
            unless explicitly stated. Users should independently verify payment
            details and seek professional advice before entering any binding
            agreement.
          </p>
        </div>

        {/* Disputes */}
        <div>
          <h2 className="text-2xl font-semibold mb-4">Dispute Resolution</h2>
          <p className="text-gray-600">
            If a dispute arises, we encourage parties to communicate directly
            and professionally. Where required, users may seek independent
            mediation or legal advice through appropriate state or territory
            bodies.
          </p>
        </div>

        {/* Disclaimer */}
        <div className="border-t pt-8">
          <h2 className="text-2xl font-semibold mb-4">Important Disclaimer</h2>
          <p className="text-gray-600">
            AirArrange is a technology platform that facilitates discovery and
            connection only. We are not a party to any lease agreement and do
            not provide legal, financial, or property advice.
          </p>
        </div>
      </section>
    </div>
  );
}

export default TrustAndSafety;
